import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { Autocomplete, Box, Breadcrumbs, Button, Card, Grid, IconButton, Link, Menu, MenuItem, Modal, CircularProgress, Paper, TextField, Typography, Avatar, Badge, Checkbox, ListItemText } from '@mui/material'
import { height, Stack, width } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import Appbar from '../../components/Appbar'
import Body from '../../layout/Body'
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from "yup";
import { styled } from '@mui/material/styles';
import { createPartnerAction } from '../../redux/toolkit/partner/createPartner'
import { uplodImageAction } from '../../redux/toolkit/image/uplodImage';
import SnackBarUI from '../../comman/SnackBarUI';
import { getAllPartnerAction } from '../../redux/toolkit/partner/allPartner'

import InputLabel from '@mui/material/InputLabel';
// import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


const breadcrumb = (
    <Stack>
        <Breadcrumbs separator={<NavigateNextIcon sx={{ color: '#5E6C8A' }} fontSize="small" />} aria-label="breadcrumb">
            <Link underline="hover" sx={{ color: "#5E6C8A" }} color='inherit' href='/'>Home</Link>
            <Link underline="hover" sx={{ color: "#5E6C8A" }} color='inherit' href='/partner'>Create Partner</Link>
        </Breadcrumbs>
        <Typography sx={{ color: "#5E6C8A" }} variant='h4'>Partners</Typography>
    </Stack>
)



const partnerSchema = yup.object({
    name: yup.string().required('Partner Name is required'),
    minEarning: yup
    .number().required('Min Earning is required.')
    .typeError('Min Earning is always number'),
    maxEarning: yup
    .number().required('Max Earning  is required.')
    .typeError('Max Earning is always number'),
    image: yup.string().required('Image  is required.'),
    // borderColor: yup.string().required('Border Color  is required.'),
    trackLink: yup.string().required('Track Link is required.'),
    description: yup.string().required('Description  is required.'),
    ratings: yup
    .number().required('Ratings  is required.')
    .max(5, 'Ratings must be less than or equal to 5')
    .typeError('Ratings is always number'),
    // bg_color: yup.array().required('Bg Color  is required.'),
    ipSurveyLimit: yup
    .number().required('Ip Survey Limit  is required.')
    .typeError('Ip Survey Limit is always number'),
    callBackCompletedSurveyLimit: yup
    .number()
    .required('Call Back Completed Survey Limit  is required.')
    .typeError('Charge Back Limit is always number'),
    callbackScreenoutSurveyLimit: yup
    .number().required('Call Back ScreenOut Survey Limit  is required.')
    .typeError('Call Back ScreenOut Survey Limit is always number'),
    attemptedSurveyLimit: yup
    .number()
    .required('Attempted Survey Limit  is required.')
    .typeError('Attempted Survey Limit is always number'),
    chargeBackLimit: yup
    .number()
    .required('Charge Back Limit  is required.')
    .typeError('Charge Back Limit is always number'),
    whitelisted_ips: yup.string(),
}).required();




export default function AddPartner({ state, setState, partnerId }) {


    const [image, setImage] = useState('')
    const [snack, setSnack] = useState(false)

    // const [theme, setTheme] = useState([1]);
    const [category, setCategory] = useState([1]);

    // const [color1, setColor1] = useState('')
    // const [color2, setColor2] = useState('')
    // const [color3, setColor3] = useState('')


    const { register, setValue, setError, watch, handleSubmit, formState: { errors }, reset } = useForm({ resolver: yupResolver(partnerSchema) });

    const dispatch = useDispatch()
    const createPart = useSelector(state => state.createPartner)
    let { status, message, loading } = createPart



    const handleAddPartner = async (data) => {
        data.category = category
        
        // Convert whitelisted_ips string to array
        if (data.whitelisted_ips) {
            data.whitelisted_ips = data.whitelisted_ips
                .split(/[\n,]+/)
                .map(ip => ip.trim())
                .filter(ip => ip.length > 0);
        } else {
            data.whitelisted_ips = [];
        }
        
        const createPartner = await dispatch(createPartnerAction({ ...data }))
        if (createPartner?.payload?.status === 200) {
            await dispatch(getAllPartnerAction())
        }
        setSnack(true)
        setState(false)


    }





    const handleClose = () => {
        setState(false)
    }

    const handleImage = async (e) => {

        const formData = new FormData();

        const file = e.target.files[0];

        formData.append('file', file);

        let FileSize = Number(e.target.files[0].size / 1000);

        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var width, height;


        img.onload = async function () {
            width = this.width;
            height = this.height;
           
            // if (height < 32 && width < 106) {
                let uploadedImg = await dispatch(uplodImageAction(formData))
                const imgStr = uploadedImg?.payload?.data?.url;
                setImage(uploadedImg?.payload?.data?.url)
                setValue('image', imgStr)
                alert(`Image is Successfully Uploaded, Your file size is ${FileSize}`);
            // } else {
            //     alert(
            //         `Image height less then 32px  & and width less then 106px, Your height=${height} & width=${width}`
            //     );
            // }
        };
        img.onerror = function () {
            alert("not a valid file: " + file.type);
        };
        img.src = _URL.createObjectURL(file);


    }

    const handleChange2 = (event) => {
        setCategory(event.target.value)
    };

    const categoryOptions = {
        1: 'survey',
        2: 'offerwall',
        3: 'survey router',
    };

    const selectedCategoryLabels = category.map(value => categoryOptions[value]);


    return (
        <>
            <Helmet><title> Survey Wall | Q & A</title></Helmet>
            <Appbar breadcrumb={breadcrumb} />
            <Body>

                <Modal
                    sx={{ overflow: 'scroll' }}
                    open={state}
                    onClose={handleClose}
                >
                    <Box className="modal_box">
                        <Card sx={{ width: 500, p: 5 }}>
                            <Typography variant="h5" sx={{ mb: 5 }} align="center">
                                Create Partner
                            </Typography>

                            <form sx={{ height: "auto" }} onSubmit={handleSubmit(handleAddPartner)}>
                                <Grid container spacing={2}>
                                    {/* First Column */}
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Name"
                                            variant="outlined"
                                            placeholder="Name"
                                            {...register("name")}
                                            error={!!errors?.name?.message}
                                            helperText={errors?.name?.message}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Min Earning"
                                            variant="outlined"
                                            placeholder="Min Earning"
                                            {...register("minEarning")}
                                            error={!!errors?.minEarning?.message}
                                            helperText={errors?.minEarning?.message}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Max Earning"
                                            variant="outlined"
                                            placeholder="Max Earning"
                                            {...register("maxEarning")}
                                            error={!!errors?.maxEarning?.message}
                                            helperText={errors?.maxEarning?.message}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField type='file' accept="image/*" variant="outlined" id='image-upload' placeholder='image' onChange={handleImage} error={errors?.image?.message} helperText={errors?.image?.message} />
                                        <Badge anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} >
                                            <Avatar src={image} sx={{ width: 100 ,borderRadius:'0%' , marginTop: 1 }} />
                                        </Badge>


                                    </Grid>
                                    {/* <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Border Color"
                                            variant="outlined"
                                            placeholder="Border Color"
                                            {...register("borderColor")}
                                            error={!!errors?.borderColor?.message}
                                            helperText={errors?.borderColor?.message}
                                        />
                                    </Grid> */}
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Rating"
                                            variant="outlined"
                                            placeholder="Rating"
                                            {...register("ratings")}
                                            error={!!errors?.ratings?.message}
                                            helperText={errors?.ratings?.message}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Description"
                                            variant="outlined"
                                            placeholder="Description"
                                            {...register("description")}
                                            error={!!errors?.description?.message}
                                            helperText={errors?.description?.message}
                                        />
                                    </Grid>




                                    {/* <Grid container spacing={2} mt={2}>
                                        <Grid container ml={2} spacing={3}>
                                            
                                            <Grid item xs={12} sm={6}>
                                                <input
                                                    type="color"
                                                    onChange={(e) => colorChange(e, 0)}
                                                    style={{ cursor: "pointer", width: "20%", height: "40px", border: "none" }}
                                                />
                                                <Box
                                                    sx={{
                                                        width: "100%",
                                                        height: "50px",
                                                        backgroundColor: color1,
                                                        border: "1px solid #ccc",
                                                        borderRadius: "4px",
                                                        position: "relative",
                                                    }}
                                                >
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <input
                                                    type="color"
                                                    onChange={(e) => colorChange(e, 1)}
                                                    style={{ cursor: "pointer", width: "20%", height: "40px", border: "none" }}
                                                />
                                                <Box
                                                    sx={{
                                                        width: "100%",
                                                        height: "50px",
                                                        backgroundColor: color2,
                                                        border: "1px solid #ccc",
                                                        borderRadius: "4px",
                                                        position: "relative",
                                                    }}
                                                >
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <input
                                                    type="color"
                                                    onChange={(e) => colorChange(e, 2)}
                                                    style={{ cursor: "pointer", width: "20%", height: "40px", border: "none" }}
                                                />
                                                <Box
                                                    sx={{
                                                        width: "100%",
                                                        height: "50px",
                                                        backgroundColor: color3,
                                                        border: "1px solid #ccc",
                                                        borderRadius: "4px",
                                                        position: "relative",
                                                    }}
                                                >
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                            <div style={{
                                                width:"100%",
                                                height:"100%",
                                              
                                                background:`linear-gradient(to right, ${color1}, ${color2}, ${color3})`
                                            }}>

                                            </div>
                                            </Grid>
                                        </Grid>
                                    </Grid> */}


                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="TrackLink"
                                            variant="outlined"
                                            placeholder="TrackLink"
                                            {...register("trackLink")}
                                            error={!!errors?.trackLink?.message}
                                            helperText={errors?.trackLink?.message}
                                        />
                                    </Grid>

                                    {/* <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Ip Limit"
                                            variant="outlined"
                                            placeholder="Ip Limit"
                                            {...register("ip_survey_limit")}
                                            error={!!errors?.ip_survey_limit?.message}
                                            helperText={errors?.ip_survey_limit?.message}
                                        />
                                    </Grid> */}



                                    <Grid item xs={12} sm={6} >
                                        <Stack direction="row" spacing={10} sx={{ margin: "0px 0px 0px 0px" }}>
                                            <Box sx={{ minWidth: 200 }}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">
                                                        Category
                                                    </InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        value={category}
                                                        label="Category"
                                                        onChange={handleChange2}
                                                        multiple
                                                        renderValue={(selected) => {

                                                            return selected.map(value => categoryOptions[value]).join(', ');
                                                        }}
                                                    >
                                                        <MenuItem value={1}>
                                                            <Checkbox checked={category.indexOf(1) > -1} />
                                                            <ListItemText primary="Survey" />
                                                        </MenuItem>
                                                        <MenuItem value={2}>
                                                            <Checkbox checked={category.indexOf(2) > -1} />
                                                            <ListItemText primary="Offerwall" />
                                                        </MenuItem>
                                                        <MenuItem value={3}>
                                                            <Checkbox checked={category.indexOf(3) > -1} />
                                                            <ListItemText primary="Survey Router" />
                                                        </MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </Stack>

                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Ip Survey Limit"
                                            variant="outlined"
                                            placeholder="Ip Survey Limit"
                                            {...register("ipSurveyLimit")}
                                            error={!!errors?.ipSurveyLimit?.message}
                                            helperText={errors?.ipSurveyLimit?.message}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Call Back ScreenOut Survey"
                                            variant="outlined"
                                            placeholder="Call Back ScreenOut Survey"
                                            {...register("callbackScreenoutSurveyLimit")}
                                            error={!!errors?.callbackScreenoutSurveyLimit?.message}
                                            helperText={errors?.callbackScreenoutSurveyLimit?.message}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Call Back Completed Survery Limit"
                                            variant="outlined"
                                            placeholder="Call Back Completed Survery Limit"
                                            {...register("callBackCompletedSurveyLimit")}
                                            error={!!errors?.callBackCompletedSurveyLimit?.message}
                                            helperText={errors?.callBackCompletedSurveyLimit?.message}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Attempted Survey Limit"
                                            variant="outlined"
                                            placeholder="Attempted Survey Limit"
                                            {...register("attemptedSurveyLimit")}
                                            error={!!errors?.attemptedSurveyLimit?.message}
                                            helperText={errors?.attemptedSurveyLimit?.message}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Charge Back Limit"
                                            variant="outlined"
                                            placeholder="Charge Back Limit"
                                            {...register("chargeBackLimit")}
                                            error={!!errors?.chargeBackLimit?.message}
                                            helperText={errors?.chargeBackLimit?.message}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Whitelisted IPs"
                                            variant="outlined"
                                            placeholder="Enter IPs (one per line or comma-separated)"
                                            multiline
                                            rows={4}
                                            {...register("whitelisted_ips")}
                                            error={!!errors?.whitelisted_ips?.message}
                                            helperText={errors?.whitelisted_ips?.message || "Enter IP addresses separated by commas or new lines"}
                                        />
                                    </Grid>

                                </Grid>

                                <Stack direction="row" spacing={2} mt={3}>
                                    <Button sx={{ zIndex: 1000 }} variant='contained' type='submit' disabled={loading}>{loading ? <CircularProgress /> : 'Create Partner'}</Button>

                                    <Button variant="contained" color="error" onClick={handleClose}>
                                        Close
                                    </Button>
                                </Stack>

                            </form>
                        </Card>
                    </Box>
                </Modal>

                <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />

            </Body>
        </>
    )
}


